/*! @pentacode/ui v0.1.0 */
import { FormElement as e } from "../formElement.js";
import "../../icon-DW8BBY5W.js";
import { t } from "../../styledElement-DUAqv8gi.js";
import { InputLabel as n } from "./input-label.js";
import { t as r } from "../../decorateMetadata-BXz2gmG4.js";
import { t as i } from "../../decorate-C_HUHFGG.js";
import { LitElement as a, html as o, nothing as s } from "lit";
import { customElement as c, property as l, state as u } from "lit/decorators.js";
// src/elements/form-elements/select.ts
var d = class extends t(e(a)) {
	constructor(...e) {
		super(...e), this.options = [], this.placeholder = "-- Bitte wählen --", this.name = "", this.label = void 0, this.disabled = !1, this.required = !1, this.chevronStyle = "background", this.selectedOption = null;
	}
	createSelectChangeEvent(e) {
		return new CustomEvent("change", {
			detail: {
				value: e.value,
				option: e
			},
			bubbles: !0,
			composed: !0
		});
	}
	connectedCallback() {
		super.connectedCallback(), this.value && this.options.length > 0 && (this.selectedOption = this.options.find((e) => e.value === this.value) || null);
	}
	handleSelectChange(e) {
		let t = e.target.value, n = this.options.find((e) => e.value === t);
		n && !n.disabled && (this.selectedOption = n, this.value = n.value, this.dispatchEvent(this.createSelectChangeEvent(n)));
	}
	renderChevronIcon() {
		return o`
            <ptc-ui-icon
                name="icon.toggle.expand-active"
                class="pointer-events-none absolute top-1/2 right-2 h-4 w-4 -translate-y-1/2 text-gray-500"
            ></ptc-ui-icon>
        `;
	}
	render() {
		let e = !this.selectedOption, t = this.chevronStyle === "background" ? "background-image: url('data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 version=%271.1%27 height=%2710px%27 width=%2720px%27%3E%3Ctext x=%270%27 y=%2710%27 %3E%E2%96%BE%3C/text%3E%3C/svg%3E');" : "";
		return o`
            <div class="relative">
                ${this.label ? n(this.label) : s}
                <select
                    name="${this.name}"
                    ?disabled="${this.disabled}"
                    ?required="${this.required}"
                    @change="${this.handleSelectChange}"
                    class="${this.chevronStyle === "background" ? "bg-[length:1.5em_1em] bg-right bg-no-repeat" : ""} w-full cursor-pointer appearance-none rounded-md border border-gray-300 bg-white px-3 py-2 pr-8 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none disabled:cursor-not-allowed disabled:bg-gray-100"
                    style="${t}"
                >
                    ${e ? o`<option value="" selected disabled>${this.placeholder}</option>` : ""}
                    ${this.options.map((e) => o`
                            <option
                                value="${e.value}"
                                ?disabled="${e.disabled}"
                                ?selected="${this.selectedOption?.value === e.value}"
                            >
                                ${e.label}
                            </option>
                        `)}
                </select>
                ${this.chevronStyle === "icon" ? this.renderChevronIcon() : ""}
            </div>
        `;
	}
};
i([l({ type: Array }), r("design:type", Array)], d.prototype, "options", void 0), i([l({
	type: String,
	attribute: "placeholder"
}), r("design:type", Object)], d.prototype, "placeholder", void 0), i([l({
	type: String,
	attribute: "name"
}), r("design:type", Object)], d.prototype, "name", void 0), i([l({
	type: String,
	attribute: "label"
}), r("design:type", Object)], d.prototype, "label", void 0), i([l({ type: Boolean }), r("design:type", Object)], d.prototype, "disabled", void 0), i([l({ type: Boolean }), r("design:type", Object)], d.prototype, "required", void 0), i([l({ type: String }), r("design:type", String)], d.prototype, "chevronStyle", void 0), i([u(), r("design:type", Object)], d.prototype, "selectedOption", void 0), d = i([c("ptc-ui-select")], d);
export { d as Select };

//# sourceMappingURL=select.js.map